// import { EncryptStorage } from 'encrypt-storage';
import { encode, decode } from 'js-base64';

// Example of secret_key variable in an .env file
// const encryptStorage = new EncryptStorage(process.env.SECRET_KEY, options);
// const encryptStorage = new EncryptStorage('my-secret', {
//   prefix: '@uprank-',
//   storageType: 'localStorage',
//   encAlgorithm: 'AES',
// });
// export default encryptStorage;
export interface PersistStorage {
  setItem(key: string, value: any): void | Promise<void>;
  getItem(key: string): null | string | Promise<string>;
  mergeItem?(key: string, value: string): Promise<void>;
  clear?(): void;
}
const localStorageBase64 = (): PersistStorage => ({
  setItem: (key: string, value: string): void => {
    localStorage.setItem(key, encode(value));
  },
  getItem: (key: string): null | string | Promise<string> => {
    const raw = localStorage.getItem(key);
    return raw ? decode(raw || '') : null;
  },
  clear: (): void => {
    localStorage.clear();
  },
});
export default localStorageBase64;
